export default "__VITE_ASSET__7db2448f__"